import { useEffect, useState } from "react";
import { CheckCircle2, AlertTriangle, XCircle } from "lucide-react";
import { api } from "../../api";
import { APageHead, AMetric } from "../adminKit";

const dot = (s) => s === "operational" ? "text-emerald-400" : s.includes("down") ? "text-red-400" : "text-amber-400";
const Icon = ({ s }) => s === "operational" ? <CheckCircle2 size={18} className="text-emerald-400" /> : s.includes("down") ? <XCircle size={18} className="text-red-400" /> : <AlertTriangle size={18} className="text-amber-400" />;

export default function AdminSystem() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/system").then(({ data }) => setD(data)); }, []);
  if (!d) return <div className="text-slate-500">Loading…</div>;
  return (
    <div className="space-y-5">
      <APageHead title="System Health" subtitle="Live service status. No secret keys, credentials, or raw environment variables are exposed." />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <AMetric label="Version" value={d.version} />
        <AMetric label="Environment" value={d.environment} tone="blue" />
        <AMetric label="Services Up" value={`${d.services.filter((s) => s.status === "operational").length}/${d.services.length}`} tone="green" />
        <AMetric label="Recent Errors" value={d.recent_errors.length} tone={d.recent_errors.length ? "red" : "green"} />
      </div>
      <div className="cc-card rounded-2xl p-5">
        <h3 className="cc-heading text-base font-500 text-white mb-4">Services</h3>
        <div className="space-y-2">
          {d.services.map((s) => (
            <div key={s.name} className="flex items-center justify-between rounded-lg cc-surface border border-white/[0.05] px-4 py-3">
              <span className="text-sm text-slate-200">{s.name}</span>
              <span className={`flex items-center gap-2 text-sm capitalize ${dot(s.status)}`}><Icon s={s.status} /> {s.status}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
